import { HStack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TotalAmountProps {
  shippingFee: string
  total: string
}

const TotalAmount: React.FC<TotalAmountProps> = ({ shippingFee, total }) => {
  const { t } = useTranslation()
  return (
    <VStack align='stretch' spacing={2} my={4}>
      <HStack justifyContent='space-between'>
        <Text>{t('cartPages.shippingFee')}</Text>
        <Text>{shippingFee}</Text>
      </HStack>
      <HStack justifyContent='space-between'>
        <Text>{t('cartPages.totalAmount')}</Text>
        <Text>{total}</Text>
      </HStack>
    </VStack>
  )
}

export default TotalAmount
